// Javascript that goes with accountLimitations.jsp
var cancelPendingJSON = {
	success: function(o){
		// hide div (day 5, week 6 month 7)
		var params = YAHOO.lang.JSON.parse(o.responseText);
		if  (params.TIME_CONST === 5) {
			document.getElementById('pl-container-daily').style.display = 'none';
			removeDailyLimit = 'null';
		} else if  (params.TIME_CONST === 6) {
			document.getElementById ('pl-container-weekly').style.display='none';
			removeWeeklyLimit = 'null';
		} else if  (params.TIME_CONST === 7) {
			document.getElementById ('pl-container-monthly').style.display='none';
			removeMonthlyLimit = 'null';
		}
	},
	failure: function(o) {

	},
	cache: false,
	timeout: 5000
};

var cancelWagerPendingJSON = {
	success: function(o){
		// hide div (day 5, week 6 month 7)
		var params = YAHOO.lang.JSON.parse(o.responseText);
		if  (params.TIME_CONST === 5) {
			document.getElementById('pl-container-daily-wager').style.display = 'none';
			removeDailyLimit = 'null';
		} else if  (params.TIME_CONST === 6) {
			document.getElementById ('pl-container-weekly-wager').style.display='none';
			removeWeeklyLimit = 'null';
		} else if  (params.TIME_CONST === 7) {
			document.getElementById ('pl-container-monthly-wager').style.display='none';
			removeMonthlyLimit = 'null';
		}
	},
	failure: function(o) {

	},
	cache: false,
	timeout: 5000
};

// cancels pending request to remove limit or to increase limit
function cancelPendingLimit(timeConst) {
	YAHOO.util.Connect.asyncRequest('POST',
		domainUrl,
		cancelPendingJSON,
		'flow=cancelPendingLimit' + '&timeConst=' + timeConst);
}

// cancels pending request to remove wager limit or to increase limit
function cancelPendingWagerLimit(timeConst) {
	YAHOO.util.Connect.asyncRequest('POST',
		domainUrl,
		cancelWagerPendingJSON,
		'flow=cancelPendingWagerLimit' + '&timeConst=' + timeConst);
}

function startsWith(str, pattern) {
    return (str.match("^"+pattern) === pattern);
}

function endsWith(str, pattern) {
    return (str.match(pattern+"$") === pattern);
}
function expand(item, subjectTag, messageTag) {
    var msg = "msg-" + item;
    var subj = "subj-" + item;

    //Get all elements on the page
    var subjectTags = document.getElementsByTagName(subjectTag);

    //Loop through subjects
    for(var i = 0; i < subjectTags.length; i++) {
        var s_tag = subjectTags[i].id;

        if(startsWith(s_tag, "subj-")) {
            var tag = new YAHOO.util.Element(s_tag);

            if(s_tag == subj) {
                if(tag.hasClass('notselected')) {
                    tag.replaceClass('notselected' , 'selected');
                }
            } else {
                if(tag.hasClass('selected')) {
                    tag.replaceClass('selected' , 'notselected');
                }
            }
        }
    }
    var messageTags = document.getElementsByTagName(messageTag);
    //Loop through messages
    for(var j = 0; j < messageTags.length; j++) {
        var m_tag = messageTags[j].id;
        if(startsWith(m_tag, "msg-")) {
            var tag = new YAHOO.util.Element(m_tag);
            if(m_tag == msg) {
             if(tag.getStyle('display') == displayStatus){
                 tag.setStyle('display', 'none');
            }
             else{
                tag.setStyle('display', displayStatus);
             }
                } else {
                tag.setStyle('display', 'none');
            }
        }
    }
    return false;
}

function initializeBlockAccount(){
	window.top.dialog.load('PlayerCloseAccount');
}

function finalizeBlockAccount(){
	if ($('#reasonSelected').val() == 'true') 	{
		var reason = $('#PARAM_RESPONSIBLE_GAMING_NOTES').val();
		if(reason === '6'){
			window.top.dialog.close('PlayerCloseAccount');
			window.top.dialog.load('responsiblegaming/UKResGamingAccountClose');
		} else {
			$('#confirmexcludeform7').submit(function(){
				$.ajax({
					url: $('#confirmexcludeform7').attr('action'),
					type: 'POST',
					data : $('#confirmexcludeform7').serialize(),
					success: function(data){
						window.top.dialog.close('PlayerCloseAccount');
						window.top.showInfoMessage(data.RESP_GAMING_SUBHEADER, data.RESP_GAMING_MESSAGE, data.BUTTON_TEXT,
							false, null, null, data.RESP_GAMING_HEADER);
						setTimeout(window.top.navigation.gotoLastProductPage, 3000);
					}
				});
				return false;
			});
			$('#confirmexcludeform7').submit();
		}
	} else {
		$('#REASON_CHECKED').attr('class', 'fieldstatus-error');
	}
}

function cancelAccountClose(){
	window.top.dialog.close('PlayerCloseAccount');
}

function handleUKResponsibleGamingAccountClose(){
	var timeout = $('#uk_res_gaming_account_close_duration').val();
	var duration = $('#uk_res_gaming_account_close_duration option:selected').text();
	window.top.dialog.close('responsiblegaming/UKResGamingAccountClose');
	var getExclusionDate = function () {
		var excludeDate = new Date();
		var hourInMillis = 1000*60*60;
		var dayInMillis = 24*hourInMillis;

        switch (timeout){
			case "1":
				excludeDate.setTime(excludeDate.getTime() + 12*hourInMillis);
				return getFormattedExclusionDate();
				break;
			case "2":
				excludeDate.setTime(excludeDate.getTime() + 24*hourInMillis);
				return getFormattedExclusionDate();
				break;
			case "3":
				excludeDate.setTime(excludeDate.getTime() + 2*dayInMillis);
				return getFormattedExclusionDate();
				break;
			case "4":
				excludeDate.setTime(excludeDate.getTime() + 3*dayInMillis);
				return getFormattedExclusionDate();
				break;
			case "5":
				excludeDate.setTime(excludeDate.getTime() + 7*dayInMillis);
				return getFormattedExclusionDate();
				break;
			case "6":
				excludeDate.setTime(excludeDate.getTime() + 14*dayInMillis);
				return getFormattedExclusionDate();
				break;
			case "7":
				excludeDate.setTime(excludeDate.getTime() + 31*dayInMillis);
				return getFormattedExclusionDate();
				break;
			case "8":
				excludeDate.setTime(excludeDate.getTime() + 42*dayInMillis);
				return getFormattedExclusionDate();
				break;
		}

		function getFormattedExclusionDate() {
			return pad(excludeDate.getDate()) + '/' + pad((excludeDate.getMonth()+1)) + '/' + excludeDate.getFullYear()+ " "+ pad(excludeDate.getHours()) + ":"
				+ pad(excludeDate.getMinutes());
		}
		function pad(n){
			if (n === 0){
				return '00';
			}
			return (n<10)?'0'+n :n;
		}
	};
	var data = {timeout: timeout, duration:duration, excludeDate:getExclusionDate()};
	window.top.dialog.load('responsiblegaming/UKResGamingAccountCloseConfirm', data);
}

function cancelUKResponsibleGamingAccountClose(){
	window.top.dialog.close('responsiblegaming/UKResGamingAccountClose');
}

function handleUKResponsibleGamingAccountCloseConfirm(timeout){
	var RESPONSIBLE_GAMING_TIMEOUT_REASON = String(10);
	$.getJSON('/pp?flow=ResponsibleGamingUKExclude',{
		PARAM_RESPONSIBLE_GAMING_NOTES : RESPONSIBLE_GAMING_TIMEOUT_REASON,
		PARAM_RESPONSIBLE_GAMING_TIMEOUT : timeout
	}, function(data){
		window.top.showInfoMessage(data.RESP_GAMING_SUBHEADER, data.RESP_GAMING_MESSAGE, data.BUTTON_TEXT,
			false, null, null, data.RESP_GAMING_HEADER);
		setTimeout(window.top.navigation.gotoLastProductPage, 3000);
	});
	return false;
}

function cancelUKResponsibleGamingAccountCloseConfirm(){
	window.top.dialog.close('responsiblegaming/UKResGamingAccountCloseConfirm');
}

;
define("legacy/accountlimitations/accountlimitations", function(){});

